import { NEXT_PUBLIC_EVENTS_BASE_URL, NEXT_PUBLIC_EVENTS_BASE_URL_SANDBOX, SANDBOX_HOST } from "@/platform/api/constants"
import type { ImpressionBatch, SendResult } from "@/platform/observability/impressions/queue"

const BATCH_PATH = "/v1/batch"

const isSandboxMode = (): boolean => typeof window !== "undefined" && window.location.hostname === SANDBOX_HOST

const eventsBaseUrl = (): string => (isSandboxMode() && NEXT_PUBLIC_EVENTS_BASE_URL_SANDBOX) || NEXT_PUBLIC_EVENTS_BASE_URL

const batchUrl = (): string => `${eventsBaseUrl()}${BATCH_PATH}`

export const sendBatch = async (batch: ImpressionBatch): Promise<SendResult> => {
  try {
    const response = await fetch(batchUrl(), {
      method: "POST",
      keepalive: true,
      headers: { "content-type": "application/json" },
      body: JSON.stringify(batch),
    })
    return { status: response.status }
  } catch {
    return { status: 0 }
  }
}

// A false return requeues the batch, so a missing or throwing sendBeacon must report false rather than lose it.
export const sendBeaconBatch = (batch: ImpressionBatch): boolean => {
  if (typeof navigator.sendBeacon !== "function") return false
  try {
    return navigator.sendBeacon(batchUrl(), new Blob([JSON.stringify(batch)], { type: "text/plain" }))
  } catch {
    return false
  }
}
